import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, EventEmitter, Inject, Input, OnInit, Output, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { BookingController } from '@shared/src/controllers/booking/booking.controller';
import { ParticipantDto } from '@shared/src/dtos/chat/participant/ParticipantDto';
import { OptionDto } from '@shared/src/dtos/maintenance/option/OptionDto';
import { OptionsStripDto } from '@shared/src/dtos/maintenance/option/OptionsStripDto';
import { RouteDocumentaryReviewObjectDto } from '@shared/src/dtos/documentaryreview/RouteDocumentaryReviewObjectDto';
import { ChatParticipantTypes } from '@shared/src/enums/ChatParticipantTypes';
import { HardmanProducts } from '@shared/src/enums/HardmanProducts';
import { RoutePermissionTypesRules } from '@shared/src/enums/RoutePermissionTypes';
import { AlertService, HomeController, HString, PhaseCardDto, RouteController, SharedAsideFactory } from '@shared/src/public-api';
import { HLong } from '@shared/src/datatypes/HLong';
import { BookingCardItemDto } from '@shared/src/dtos/booking/BookingCardItemDto';
import { RouteCardItemExpandDto } from '@shared/src/dtos/route/RouteCardItemExpandDto';
import { PhaseCardItemDto } from '@shared/src/dtos/phase/PhaseCardItemDto';

@Component({
  selector: 'shared-active-bookings-item-route',
  templateUrl: './shared.active.bookings.item.route.html',
  styleUrls: ['./shared.active.bookings.item.route.scss']
})
export class SharedActiveBookingsItemRoute implements OnInit {

  @ViewChild('scrollContainer') scrollContainer: ElementRef;

  public useIonic: boolean = false;
  public allLoaded: boolean = true;

  constructor(protected fb: FormBuilder,
    public activatedRoute: ActivatedRoute,
    public location: Location, public router: Router,
    protected bookingController: BookingController,
    protected routeController: RouteController,
    @Inject("HomeController") protected homeController: HomeController,
    @Inject("AlertService") protected alertService: AlertService,
    @Inject('SharedAsideFactory') private sharedAsideFactory: SharedAsideFactory) {

    this.hascarrier = this.homeController.hasProduct(HardmanProducts.carrier);
    this.hasshipper = this.homeController.hasProduct(HardmanProducts.shipper);


    if (homeController.useIonic)
      this.useIonic = homeController.useIonic();
    //Fem subscribe per detectar només el location.back i location.forward que s'executen  només al anar endevant i enrera en els botons del navegador
    //Nomes ho fem amb aquests dos casos ja que o sinó esta constantment detectant canvis al canviar els parametres de url en el routeTo
    this.location.subscribe(
      ((value: PopStateEvent) => {
        console.log(value);
        this.loadParametersLocation();
      }),
      (ex => {
      })
    );
  }

  ngOnInit(): void {
    this.loadParametersLocation();
  }

  public loadParametersLocation() {

    let path = this.location.path();
    if (path == "")
      return;

    let tree = this.router.parseUrl(path);
    let queryParams = tree.queryParams;

    let optionId = queryParams[BookingController.PARAMETERASUBOPTIONIDNAME];
    if (!HString.isNullOrNullString(optionId)) {
      this.selectedOptionId = optionId;
      this.selectOption();
    }
  }

  routeTo() {
    if (!this.allLoaded || this.useIonic)
      return;

    let object = { ...this.activatedRoute.snapshot.queryParams };
    if (!HString.isNullOrNullString(this.selectedOptionId))
      object[BookingController.PARAMETERASUBOPTIONIDNAME] = this.selectedOptionId;
    else
      delete object[BookingController.PARAMETERASUBOPTIONIDNAME];

    //Aqui no estem rederigint, només estem actualtzant els queryParams perque es vegi reflectida la URL. 
    //Al no redirigir (que ja es el que volem perquè no es necessàri), no està refrescant la pagina i no entrarà pel ngOnInit()
    this.router.navigate([".", {}], { relativeTo: this.activatedRoute, queryParams: object, queryParamsHandling: '' });
  }

  public selectOption() {
    if (this.options != null) {
      if (OptionsStripDto._selectById(this.options, this.selectedOptionId))
        this.onClickOption(OptionsStripDto.getSelect(this.options));
    }
  }

  @Output() clickBack = new EventEmitter<boolean>();

  // Funcionament del component
  @Input() public readonly: boolean = false;
  public hascarrier: boolean = false;
  public hasshipper: boolean = false;
  public hasInspector: boolean = false;
  public hasHealthCertifier: boolean = false;

  // Tabs
  public selectedOptionId: string;
  public options: OptionsStripDto;

  public getOptions() {
    if (!this._route)
      return;

    this.routeController.getBookingOptions(this._route.routeId).subscribe(e => {
      if (e) {
        this.options = OptionsStripDto.buildFromOptionsStripDto(e);
        if (this.selectedOptionId)
          OptionsStripDto.selectById(this.options, this.selectedOptionId);
        this.onClickOption(this.options.getActualSelected());
      }
    })
  }

  public onClickOption(item: OptionDto) {
    if (!this._route)
      return;

    this.selectedOptionId = this.options.getActualSelected().optionId;
    this.routeTo();
  }

  // Ruta
  public chatOwner: ParticipantDto;
  @Output() public onRouteChanged: EventEmitter<RouteCardItemExpandDto> = new EventEmitter<RouteCardItemExpandDto>();
  @Output() public onRouteRefresh: EventEmitter<RouteCardItemExpandDto> = new EventEmitter<RouteCardItemExpandDto>();

  public _bookingId: number;
  @Input()
  public get bookingId(): number {
    return this._bookingId;
  }
  public set bookingId(value: number) {
    if (this._bookingId === value)
      return;
    this._bookingId = value;
    this.loadBooking();
  }


  public _routeId: number;
  @Input()
  public get routeId(): number {
    return this._routeId;
  }
  public set routeId(value: number) {
    if (this._routeId === value)
      return;
    this._routeId = value;
    if (HLong.isNullOrNullLong(this._routeId))
      return;
    this.routeController.getRouteCardItemExpand(this._routeId).subscribe(e => {
      if (e && e.routeId)
        this._route = e;
      else
        this._route = null;
      this.welcome();
    });
  }


  public async reloadRoute() {
    return new Promise(resolve => {
      if (this._route == null || HLong.isNullOrNullLong(this._route.routeId))
        resolve(false);

      this.routeController.getRouteCardItemExpand(this._route.routeId).subscribe(e => {
        if (e && e.routeId)
          this._route = e;
        else
          this._route = null;
        this.welcome();
        resolve(true);
      });

    });
  }

  private _route: RouteCardItemExpandDto;
  public set route(v: RouteCardItemExpandDto) {
    if (v && this._route && JSON.stringify(this._route) == JSON.stringify(v))
      return;

    this._route = v;

    if (this._route && this._route.routeId) {
      if (!this._route.routePermission) {
        this.reloadRoute();
      } else {
        this.welcome();
      }
    }

  }
  public get route(): RouteCardItemExpandDto {
    return this._route;
  }

  public welcome() {
    this.loadPhasesSlots();
    this.getOptions();
    this.canAssignDriverAndPlates = RoutePermissionTypesRules.canAssignDriverAndPlatesOnRoute(this._route);
    this.showAssignDriverAndPlates = RoutePermissionTypesRules.showAssignDriverAndPlatesOnRoute(this._route);

    if (this._route != null)
      this.chatOwner = ParticipantDto.buildByParams(this._route.routeId, ChatParticipantTypes.Route);
  }

  public _phasesSlots: PhaseCardItemDto[] = new Array();
  public loadPhasesSlots() {
    let phases: PhaseCardItemDto[] = new Array();

    //Només em de mostrar les que requereixen slot
    if (this.route && this.route.phases && this.route.phases.length > 0) {
      this.route.phases.forEach(element => {
        if (element.requiresSlot) {
          phases.push(element);
        }
      });
    }
    this._phasesSlots = phases;
  }

  public async refreshRoute($event: any) {
    await this.reloadRoute();
    this.onRouteChanged.next(this._route);
  }

  //Partners i matrícules
  public canAssignDriverAndPlates: boolean = true;
  public showAssignDriverAndPlates: boolean = true;


  // Booking
  public booking: BookingCardItemDto;
  public loadBooking() {
    if (HLong.isNullOrNullLong(this.bookingId))
      return;
    this.bookingController.getBookingCardItem(this.bookingId).subscribe(e => {
      if (e && e.bookingId)
        this.booking = e;
    })
  }

  //ManagementModel
  public onRouteDocumentaryReviewUpdated(routeDocumentaryReview: RouteDocumentaryReviewObjectDto) {
    if (routeDocumentaryReview == null || !routeDocumentaryReview.routeId) {
      return;
    }

    this.reloadRoute();
    this.onRouteRefresh.next(this._route);
  }


  onMarkerClick(phase: PhaseCardDto) {
    this.sharedAsideFactory.invokeAddressCoordinates(phase.addressId, phase.formattedAddress, phase.longitude, phase.latitude);
  }

  onClickBack(event) {
    this.resetScroll();
    this.clickBack.next(true);
  }


  resetScroll() {
    if (this.scrollContainer) {
      this.scrollContainer.nativeElement.scrollTop = 0;
      if (this.scrollContainer.nativeElement.parentElement != null)
        this.scrollContainer.nativeElement.parentElement.scrollTop = 0;
    }
  }

  // Debug
  pretty(val: any) {
    return JSON.stringify(val);
  }
}
